import { render, staticRenderFns } from "./ToDoListPriorityDialog.vue?vue&type=template&id=0fe87f4c&scoped=true&"
import script from "./ToDoListPriorityDialog.vue?vue&type=script&lang=js&"
export * from "./ToDoListPriorityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe87f4c",
  null
  
)

export default component.exports